var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_508_1454",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_508_1454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33341 31.9998C4.60008 31.9998 3.9723 31.7387 3.45008 31.2165C2.92786 30.6943 2.66675 30.0665 2.66675 29.3332C2.66675 28.5998 2.92786 27.9721 3.45008 27.4498C3.9723 26.9276 4.60008 26.6665 5.33341 26.6665H26.6667C27.4001 26.6665 28.0279 26.9276 28.5501 27.4498C29.0723 27.9721 29.3334 28.5998 29.3334 29.3332C29.3334 30.0665 29.0723 30.6943 28.5501 31.2165C28.0279 31.7387 27.4001 31.9998 26.6667 31.9998H5.33341ZM5.33341 22.6665V18.8998C5.33341 18.7221 5.36675 18.5498 5.43341 18.3832C5.50008 18.2165 5.60008 18.0665 5.73341 17.9332L20.2667 3.43317C20.5112 3.18873 20.7945 2.99984 21.1167 2.8665C21.439 2.73317 21.7779 2.6665 22.1334 2.6665C22.489 2.6665 22.8334 2.73317 23.1667 2.8665C23.5001 2.99984 23.8001 3.19984 24.0667 3.4665L25.9001 5.33317C26.1667 5.57762 26.3612 5.8665 26.4834 6.19984C26.6056 6.53317 26.6667 6.87761 26.6667 7.23317C26.6667 7.5665 26.6056 7.89428 26.4834 8.2165C26.3612 8.53873 26.1667 8.83317 25.9001 9.09984L11.4001 23.5998C11.2667 23.7332 11.1167 23.8332 10.9501 23.8998C10.7834 23.9665 10.6112 23.9998 10.4334 23.9998H6.66675C6.28897 23.9998 5.9723 23.8721 5.71675 23.6165C5.46119 23.361 5.33341 23.0443 5.33341 22.6665ZM22.1334 9.0665L24.0001 7.19984L22.1334 5.33317L20.2667 7.19984L22.1334 9.0665Z",
    fill: "#707A8D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.73cd60e77ea2d09f7d4ca4a5098be079.svg";
export { ForwardRef as ReactComponent };